var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "worldcup-page" }, [
    _c("div", { staticClass: "worldcup-hero" }, [
      _vm._m(0),
      _c(
        "button",
        { staticClass: "refresh-btn", on: { click: _vm.getMatches } },
        [_vm._v("刷新赛程")]
      ),
    ]),
    _c(
      "div",
      { staticClass: "competition-tabs" },
      [
        _c(
          "button",
          {
            class: { active: _vm.query.competitionCode === "" },
            on: {
              click: function ($event) {
                return _vm.setCompetition("")
              },
            },
          },
          [_vm._v("全部赛事")]
        ),
        _vm._l(_vm.competitions, function (item) {
          return _c(
            "button",
            {
              key: item.code,
              class: { active: _vm.query.competitionCode === item.code },
              on: {
                click: function ($event) {
                  return _vm.setCompetition(item.code)
                },
              },
            },
            [_vm._v(" " + _vm._s(item.name || item.code) + " ")]
          )
        }),
      ],
      2
    ),
    _c("div", { staticClass: "filters" }, [
      _c(
        "button",
        {
          class: { active: _vm.query.status === "" },
          on: {
            click: function ($event) {
              return _vm.setStatus("")
            },
          },
        },
        [_vm._v("全部")]
      ),
      _c(
        "button",
        {
          class: { active: _vm.query.status === "Scheduled" },
          on: {
            click: function ($event) {
              return _vm.setStatus("Scheduled")
            },
          },
        },
        [_vm._v("未开赛")]
      ),
      _c(
        "button",
        {
          class: { active: _vm.query.status === "InPlay" },
          on: {
            click: function ($event) {
              return _vm.setStatus("InPlay")
            },
          },
        },
        [_vm._v("进行中")]
      ),
      _c(
        "button",
        {
          class: { active: _vm.query.status === "Finished" },
          on: {
            click: function ($event) {
              return _vm.setStatus("Finished")
            },
          },
        },
        [_vm._v("已结束")]
      ),
    ]),
    _vm.loading
      ? _c("div", { staticClass: "state" }, [_vm._v("赛程加载中...")])
      : _vm.matches.length === 0
      ? _c("div", { staticClass: "state" }, [_vm._v("暂无赛程")])
      : _c(
          "div",
          { staticClass: "match-list" },
          _vm._l(_vm.matches, function (match) {
            return _c(
              "div",
              {
                key: match.id,
                staticClass: "match-row",
                on: {
                  click: function ($event) {
                    return _vm.goDetail(match.id)
                  },
                },
              },
              [
                _c("div", { staticClass: "match-time" }, [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.formatDate(match.startTime))),
                  ]),
                  _c("em", [
                    _vm._v(_vm._s(_vm.competitionName(match.competitionCode))),
                  ]),
                  _c("span", [_vm._v(_vm._s(_vm.getStatusName(match.status)))]),
                ]),
                _c("div", { staticClass: "teams" }, [
                  _c("div", { staticClass: "team" }, [
                    match.homeTeamLogoUrl
                      ? _c("img", {
                          staticClass: "team-logo",
                          attrs: { src: match.homeTeamLogoUrl, alt: "" },
                          on: { error: _vm.hideBrokenImage },
                        })
                      : _vm._e(),
                    _c("span", { staticClass: "team-name" }, [
                      _vm._v(
                        _vm._s(
                          _vm.teamName(
                            match.competitionCode,
                            match.homeTeamCode,
                            match.homeTeam
                          )
                        )
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "score" },
                    [
                      match.homeScore !== null && match.homeScore !== undefined
                        ? [
                            _vm._v(
                              " " +
                                _vm._s(match.homeScore) +
                                " : " +
                                _vm._s(match.awayScore) +
                                " "
                            ),
                          ]
                        : [_vm._v("VS")],
                    ],
                    2
                  ),
                  _c("div", { staticClass: "team right" }, [
                    _c("span", { staticClass: "team-name" }, [
                      _vm._v(
                        _vm._s(
                          _vm.teamName(
                            match.competitionCode,
                            match.awayTeamCode,
                            match.awayTeam
                          )
                        )
                      ),
                    ]),
                    match.awayTeamLogoUrl
                      ? _c("img", {
                          staticClass: "team-logo",
                          attrs: { src: match.awayTeamLogoUrl, alt: "" },
                          on: { error: _vm.hideBrokenImage },
                        })
                      : _vm._e(),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "odds" },
                  _vm._l(_vm.winDrawLose(match), function (market) {
                    return _c("span", { key: market.selectionKey }, [
                      _vm._v(
                        " " +
                          _vm._s(market.selectionName) +
                          " " +
                          _vm._s(_vm.formatOdds(market.odds)) +
                          " "
                      ),
                    ])
                  }),
                  0
                ),
                _c("button", { staticClass: "detail-btn" }, [_vm._v("详情")]),
              ]
            )
          }),
          0
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h1", [_vm._v("欢乐足球")]),
      _c("p", [_vm._v("世界杯与欧洲五大联赛竞猜-本页面纯娱乐，禁止赌博")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }